import { MAP_TYPES } from '@deck.gl/carto';
 
const HISTORICALHCCLINTERSECTION_SOURCE_ID = 'historicalHCCLIntersectionSource';
 
const source = {
  id: HISTORICALHCCLINTERSECTION_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'historical_hccl_intersection_source',
};
 
export default source;